// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list__RL0_CRsh74{margin:var(--dixa-size-spacer-200) 0;padding:0}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/messages/MessageCustomForm.module.scss"],"names":[],"mappings":"AAAA,kBACE,oCAAA,CACA,SAAA","sourcesContent":[".list {\n  margin: var(--dixa-size-spacer-200) 0;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `list__RL0_CRsh74`
};
export default ___CSS_LOADER_EXPORT___;
